import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import OAuthButton, { OAuthSectionWrapper } from "./OAuthButtonsStyles";
import ConfigService from "@/components/service/ConfigService.js";

const OAuthButtons = () => {
  const [loading, setLoading] = useState({});
  const redirecting = Object.values(loading).some(Boolean);

  // The spinner survives the redirect in one case: the user clicks, lands on
  // the provider's page, then hits Back — the browser restores this page from
  // bfcache with the loading state still set. pageshow with `persisted` is
  // that restore; reset so the buttons are usable again.
  useEffect(() => {
    const reset = (e) => {
      if (e.persisted) setLoading({});
    };
    window.addEventListener("pageshow", reset);
    return () => window.removeEventListener("pageshow", reset);
  }, []);

  const signInWith = (service) => (e) => {
    e.preventDefault();
    setLoading({ [service]: true });
    window.location.href = ConfigService.getInstance().formulateContextPath(
      `/oauth2/authorization/${service}`,
    );
  };

  return (
    <OAuthSectionWrapper>
      <div className="mb-4 flex w-full flex-grow flex-col gap-4">
        <OAuthButton
          service="apple"
          onClick={signInWith("apple")}
          loading={loading["apple"]}
          disabled={redirecting && !loading["apple"]}
        >
          <FormattedMessage
            id="auth.continueWithApple"
            defaultMessage="Continue with Apple"
          />
        </OAuthButton>
        <OAuthButton
          service="google"
          onClick={signInWith("google")}
          loading={loading["google"]}
          disabled={redirecting && !loading["google"]}
        >
          <FormattedMessage
            id="auth.continueWithGoogle"
            defaultMessage="Continue with Google"
          />
        </OAuthButton>
      </div>
    </OAuthSectionWrapper>
  );
};

export default OAuthButtons;
